'use client';
import { Fragment as _Fragment, jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useAskInputRootActions } from '#pplx/frontend/apps/ask/ask-input/ask-input-provider/components/AskInputRootShared.js';
import { workspaceDirectorySyncKey } from '#pplx/frontend/apps/ask/ask-input/ask-input-types/index.js';
import { shouldResetQueryInputOnNavigation } from '#pplx/frontend/apps/ask/stores/queryInput.js';
import { usePrevious } from '#pplx/frontend/common/hooks/usePrevious.js';
import { usePathname } from '#pplx/frontend/router/usePathname.js';
import React, { useEffect, useLayoutEffect, useRef } from 'react';
// Resets the draft on cross-page navigation, preserving it through submission redirects.
const DraftResetOnNavigation = () => {
    const { resetInput } = useAskInputRootActions();
    const pathname = usePathname();
    const previousPathname = usePrevious(pathname);
    useLayoutEffect(() => {
        if (!shouldResetQueryInputOnNavigation(previousPathname, pathname))
            return;
        resetInput();
    }, [pathname, previousPathname, resetInput]);
    return null;
};
// WHY useEffect: sync async thread metadata into the store once per provided value.
const WorkspaceDirectorySync = ({ workspaceDirectories }) => {
    const lastSyncedKeyRef = useRef(undefined);
    const { setWorkspaceDirectories } = useAskInputRootActions();
    const syncKey = workspaceDirectorySyncKey(workspaceDirectories);
    useEffect(() => {
        if (syncKey === undefined || syncKey === lastSyncedKeyRef.current) {
            return;
        }
        setWorkspaceDirectories(workspaceDirectories ?? []);
        lastSyncedKeyRef.current = syncKey;
    }, [syncKey, workspaceDirectories, setWorkspaceDirectories]);
    return null;
};
export const AskInputRootSideEffects = ({ workspaceDirectories }) => (_jsxs(_Fragment, { children: [_jsx(DraftResetOnNavigation, {}), _jsx(WorkspaceDirectorySync, { workspaceDirectories: workspaceDirectories })] }));
//# sourceMappingURL=AskInputRootSideEffects.js.map